<template>
    <menu :class="{[menuClass]: [menuClass],'none-border': $route.name != 'Index'}">
        <a href="https://www.championat.com/" target="_blank" class="menu-logo" @click="$root.gaSend('main', 'click', 'championat')">
            <logo-app></logo-app>
        </a>
        <router-link to="/" class="back" v-if="$route.name != 'Index'" @click.native="$root.gaSend('main', 'click', 'championat')">
            <span>
                Вернуться
            </span>
        </router-link>

        <a href="#" class="menu-btn" v-if="$root.isMobile && $route.name == 'Index'"
           @click.prevent="stateMenu = !stateMenu">
            <menu-app class="menu-icon" v-if="!stateMenu"></menu-app>
            <menu-close class="close-icon" v-else></menu-close>
        </a>

        <span class="menu-disclaimer" v-if="!$root.isMobile">
            СПЕЦИАЛЬНЫЙ ПРОЕКТ
        </span>

        <div class="menu-share">
            <div class="share-links">
                <ul>
                    <li v-for="item in shareLinks">
                        <a href="#" @click.prevent="$root.Helpers.share(item.network, shareUrl(), toMain()), $root.gaSend('main', 'click', item.network)">
                            <img :src="item.img" alt="">
                        </a>
                    </li>
                </ul>
            </div>
            <heart-app></heart-app>
        </div>
    </menu>
</template>

<script>
    import logo from '@/assets/svg/logo.svg'
    import icons from '@/assets/svg/icons';

    export default {
        name: 'Menu',
        props: ['menuClass'],
        data() {
            return {
                stateMenu: false,
                shareLinks: [
                    {
                        img: '/static/svg/icons/ico__fb.svg',
                        network: 'fb'
                    },
                    {
                        img: '/static/svg/icons/ico__ok.svg',
                        network: 'ok'
                    },
                    {
                        img: '/static/svg/icons/ico__tele.svg',
                        network: 'tg'
                    },
                    {
                        img: '/static/svg/icons/ico__tw.svg',
                        network: 'tw'
                    },
                    {
                        img: '/static/svg/icons/ico__vk.svg',
                        network: 'vk'
                    }
                ]
            }
        },
        components: {
            "logo-app": logo,
            "heart-app": icons.heart,
            "menu-app": icons.menu,
            "menu-close": icons.close,
        },
        methods: {
            toMain() {
                this.$router.push('/');
            },
            shareUrl() {
                return window.location.href;
            },
        },
        watch: {
            'stateMenu'(to, from) {
                this.$store.commit('updateMenuState', to);
            }
        },
        mounted() {
            if (this.$root.isMobile) {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// Menu.vue?3133c99b